import { render } from "./add-school-administrator.vue?vue&type=template&id=e14914bc&scoped=true"
import script from "./add-school-administrator.vue?vue&type=script&lang=js"
export * from "./add-school-administrator.vue?vue&type=script&lang=js"

import "./add-school-administrator.vue?vue&type=style&index=0&id=e14914bc&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e14914bc"]])

export default __exports__